export const ProjectLogo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="22.5" fill="#000000" stroke="rgba(255,255,255,0.3)" strokeWidth="2" />
    <path d="M18 11 C18 19 30 27 30 37" fill="none" stroke="#ffffff" strokeWidth="2.6" strokeLinecap="round" />
    <path d="M30 11 C30 19 18 27 18 37" fill="none" stroke="#ffffff" strokeWidth="2.6" strokeLinecap="round" />
    <line x1="19.5" y1="16.5" x2="28.5" y2="16.5" stroke="rgba(255,255,255,0.7)" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="21" y1="24" x2="27" y2="24" stroke="rgba(255,255,255,0.7)" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="19.5" y1="31.5" x2="28.5" y2="31.5" stroke="rgba(255,255,255,0.7)" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const LabsLogo = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="labsLeafGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#D9B96A" />
        <stop offset="1" stopColor="#8C6D34" />
      </linearGradient>
    </defs>
    <path d="M21 42 C11 36 7 24 10 9 C22 11 30 21 29 34 C28.6 38.6 25.4 41.6 21 42 Z" fill="url(#labsLeafGrad)" />
    <path d="M28 40 C27 27 32 15 42 8 C44 22 39 35.5 29.5 40.5 Z" fill="url(#labsLeafGrad)" opacity="0.85" />
    <path d="M15 16 C19.5 24 23.5 31 24.5 38" stroke="rgba(0,0,0,0.28)" strokeWidth="1.4" fill="none" strokeLinecap="round" />
  </svg>
);
